export default "__VITE_ASSET__CDe_dZ7F__"